<template>
  <require from="controls/bs-toast-item"></require>

  <div class="bs-toast-list">
    <bs-toast-item message.bind="message" repeat.for="message of messages">
  </div>
</template>
